import { render, staticRenderFns } from "./stageTypeForm.vue?vue&type=template&id=74601196"
import script from "./stageTypeForm.vue?vue&type=script&lang=js"
export * from "./stageTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports